
export default function SectionNavCard({ sections, activeSectionId, onSectionSelect }) {
  const hasGroups = sections.some((s) => s.group);

  const groups = hasGroups
    ? sections.reduce((acc, section) => {
        const label = section.group || "";
        const existing = acc.find((g) => g.label === label);
        if (existing) {
          existing.items.push(section);
        } else {
          acc.push({ label, items: [section] });
        }
        return acc;
      }, [])
    : null;

  return (
    <div className="w-56 shrink-0 bg-white border border-gray-200 rounded-2xl p-3 shadow-sm self-start mt-3">
      <nav className="flex flex-col gap-0.5">
        {hasGroups ? (
          groups.map((group) => (
            <div key={group.label} className="mb-1">
              <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide px-2 py-1 mt-1">
                {group.label}
              </p>
              {group.items.map((section) => {
                const isActive = section.id === activeSectionId;
                return (
                  <button
                    key={section.id}
                    onClick={() => onSectionSelect(section.id)}
                    className={`w-full text-left rounded-lg px-3 py-1.5 transition-colors ${
                      isActive
                        ? "bg-indigo-50 text-indigo-700"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    <p className={`text-xs font-medium leading-snug ${isActive ? "text-indigo-700" : ""}`}>
                      {section.title}
                    </p>
                  </button>
                );
              })}
            </div>
          ))
        ) : (
          sections.map((section) => {
            const isActive = section.id === activeSectionId;
            return (
              <button
                key={section.id}
                onClick={() => onSectionSelect(section.id)}
                className={`w-full text-left rounded-lg px-3 py-2 transition-colors ${
                  isActive ? "bg-indigo-50 text-indigo-700" : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <p className={`text-xs font-medium leading-snug ${isActive ? "text-indigo-700" : ""}`}>
                  {section.title}
                </p>
              </button>
            );
          })
        )}
      </nav>
    </div>
  );
}
